// extracted by mini-css-extract-plugin
export default {"trashContanier":"Trash_trashContanier__XKJjv","trashSvg":"Trash_trashSvg__YkMcM"};